module.exports = __webpack_public_path__ + "img/iconWoDeYongHuTouXiang.604c9204.jpg";